// Meetings Service — Updated with firmId support
// Save as: src/services/meetingService.js

import { 
  collection, addDoc, getDocs, 
  query, where, orderBy, Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase-config';

const meetingsCollection = collection(db, 'meetings');

export const createMeeting = async (userId, meetingData, firmId) => {
  try {
    const docRef = await addDoc(meetingsCollection, {
      ...meetingData,
      userId,
      firmId: firmId,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getMeetings = async (userId, firmId) => {
  try {
    let meetings = [];

    // Get firmId records
    if (firmId) {
      try {
        const q = query(meetingsCollection, where('firmId', '==', firmId), orderBy('meetingDate', 'desc'));
        const snapshot = await getDocs(q);
        snapshot.forEach((doc) => meetings.push({ id: doc.id, ...doc.data() }));
      } catch (e) {
        const q = query(meetingsCollection, where('firmId', '==', firmId));
        const snapshot = await getDocs(q);
        snapshot.forEach((doc) => meetings.push({ id: doc.id, ...doc.data() }));
      }
    }

    // No creator-field (userId-only) fallback: meetings are read ONLY through
    // the current firm's tenant-scoped query above (firm-owned data — a
    // firm-constrained userId variant would be a strict subset of it, and a
    // userId-only query would not survive creator-read gating).

    // Deduplicate
    meetings = meetings.filter((m, i, arr) => arr.findIndex(x => x.id === m.id) === i);

    // Sort client-side
    meetings.sort((a, b) => {
      const dateA = a.meetingDate || a.createdAt?.toDate() || new Date(0);
      const dateB = b.meetingDate || b.createdAt?.toDate() || new Date(0);
      return new Date(dateB) - new Date(dateA);
    });

    return { success: true, meetings };
  } catch (error) {
    return { success: false, error: error.message, meetings: [] };
  }
};